// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InventoryUsage rows. Imported by the component itself so every modal that renders it
   (projects, milestones) gets the styles, not only those that load Projects.css. */
.inventory-row-card {
  box-shadow: var(--ds-shadow-xs);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.inventory-list-container {
  max-height: 400px;
  overflow-y: auto;
  padding-inline-end: var(--ds-space-2);
  margin-bottom: var(--ds-space-4);
}

@media (hover: hover) {
  .inventory-row-card:hover {
    border-color: var(--ds-brand) !important; /* overrides the inline border InventoryUsage sets */
    box-shadow: var(--ds-shadow-sm);
  }
}

@media (max-width: 575.98px) {
  .inventory-row-card {
    padding: var(--ds-space-3) !important; /* beats Bootstrap's p-3 utility (itself !important) */
  }
}
`, "",{"version":3,"sources":["webpack://./src/commons/Inventory/InventoryUsage.css"],"names":[],"mappings":"AAAA;mFACmF;AACnF;EACE,+BAA+B;EAC/B;;wBAEsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE;IACE,wCAAwC,EAAE,oDAAoD;IAC9F,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,qCAAqC,EAAE,sDAAsD;EAC/F;AACF","sourcesContent":["/* InventoryUsage rows. Imported by the component itself so every modal that renders it\n   (projects, milestones) gets the styles, not only those that load Projects.css. */\n.inventory-row-card {\n  box-shadow: var(--ds-shadow-xs);\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.inventory-list-container {\n  max-height: 400px;\n  overflow-y: auto;\n  padding-inline-end: var(--ds-space-2);\n  margin-bottom: var(--ds-space-4);\n}\n\n@media (hover: hover) {\n  .inventory-row-card:hover {\n    border-color: var(--ds-brand) !important; /* overrides the inline border InventoryUsage sets */\n    box-shadow: var(--ds-shadow-sm);\n  }\n}\n\n@media (max-width: 575.98px) {\n  .inventory-row-card {\n    padding: var(--ds-space-3) !important; /* beats Bootstrap's p-3 utility (itself !important) */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
